import { makeStyles } from '@fluentui/react-components';

export const useTransferConversationFormStyles = makeStyles({
    form: {
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    button: {
        alignSelf: 'end',
    },
});
